module.exports = __webpack_public_path__ + "img/9.7c52a05b.svg";